import FormPaciente from './components/pacientes/FormPaciente';
export default FormPaciente;